const pctString = (fract) => `${fract * 100}%`

export default pctString
